import { useAsyncData } from '@/hooks/useAsyncData';
import { fetchPermissionCatalog, type PermissionGroup } from '@/api/roles';

/** Каталог прав грузится один раз на монтирование — он не зависит от пользователя. */
export function usePermissionCatalog(): { catalog: PermissionGroup[] | null; error: string | null } {
  const { data, error } = useAsyncData(
    fetchPermissionCatalog,
    [],
    'Не удалось загрузить список прав.',
  );

  return { catalog: data, error };
}
